import { useWindowDimensions } from "hooks";
import LandingScreenComponent from "./LandingScreen.component";

const LandingScreen = () => {
  const { width } = useWindowDimensions();
  return <LandingScreenComponent screenWidth={width} />;
};

export default LandingScreen;
